// Каждый прогон публикуется отдельно и возвращает самостоятельный пост для
// Telegram (шапка + блок маршрута + легенда по багажу + футер). Когда в карточке
// несколько завершённых прогонов, склеиваем их в одно сообщение: одна шапка,
// блоки маршрутов подряд, объединённая (без дублей) легенда багажа и один футер.

const FOOTER_RE = /^(:exclamation:|❗)/;
const BAGGAGE_RE = /багаж/i;

interface ParsedPost {
  header: string | null;
  blocks: string[][]; // каждый блок: строка "> маршрут" + строки рейсов
  baggage: string[];
  footer: string[];
}

function parsePost(raw: string): ParsedPost {
  const lines = raw.split("\n").map((l) => l.trimEnd());

  let header: string | null = null;
  const blocks: string[][] = [];
  const baggage: string[] = [];
  const footer: string[] = [];

  let current: string[] | null = null; // открытый блок маршрута
  let footerStarted = false;

  for (const line of lines) {
    const t = line.trim();

    if (!t) {
      current = null; // пустая строка закрывает блок
      continue;
    }

    if (t.startsWith(">")) {
      current = [line];
      blocks.push(current);
      continue;
    }

    if (FOOTER_RE.test(t)) {
      footer.push(line);
      footerStarted = true;
      current = null;
      continue;
    }

    if (BAGGAGE_RE.test(t)) {
      baggage.push(line);
      current = null;
      continue;
    }

    // Строка рейса внутри текущего блока маршрута.
    if (current && !footerStarted) {
      current.push(line);
      continue;
    }

    // Первая «обычная» строка до маршрутов — это шапка.
    if (header === null) {
      header = line;
    }
  }

  return { header, blocks, baggage, footer };
}

function dedupe(lines: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const line of lines) {
    const key = line.trim();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(line);
  }
  return out;
}

export function mergeTelegramPosts(posts: string[]): string {
  const cleaned = posts
    .map((p) => (p ?? "").replace(/\\n/g, "\n"))
    .filter((p) => p.trim());

  if (cleaned.length === 0) return "";
  if (cleaned.length === 1) return cleaned[0]!.trim();

  const parsed = cleaned.map(parsePost);

  const header = parsed.find((p) => p.header)?.header ?? null;
  const blocks = parsed.flatMap((p) => p.blocks);
  const baggage = dedupe(parsed.flatMap((p) => p.baggage));
  const footer = dedupe(parsed.find((p) => p.footer.length)?.footer ?? []);

  const sections: string[] = [];
  if (header) sections.push(header);
  for (const block of blocks) sections.push(block.join("\n"));
  if (baggage.length) sections.push(baggage.join("\n"));
  if (footer.length) sections.push(footer.join("\n"));

  return sections.join("\n\n");
}
